import cls from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React from 'react';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';

const honorCards = [
  {
    id: 'since',
    img: '/images/home/honor-since.png',
    titleKey: '品牌荣誉-沙利文标题',
    xlTitleKey: '品牌荣誉-沙利文标题-xl',
    subTitleKey: '品牌荣誉-沙利文副标题',
  },
  {
    id: 'aognia',
    img: '/images/home/honor-aognia.png',
    titleKey: '品牌荣誉-标题',
    subTitleKey: '品牌荣誉-副标题',
  },
];

const honorBadges = [
  {
    img: '/images/home/honor-1.png',
    alt: 'edtech',
    id: 1,
  },
  {
    img: '/images/home/honor-2.png',
    alt: 'DIGITAL EDUCATION AWARDS',
    id: 2,
  },
  {
    img: '/images/home/honor-3.png',
    alt: 'FORTUNE',
    id: 3,
  },
  {
    img: '/images/home/honor-4.png',
    alt: 'Holon IQ',
    id: 4,
  },
  {
    img: '/images/home/honor-5.png',
    alt: 'PRESTIGE AWARDS',
    id: 5,
  },
  {
    img: '/images/home/honor-6.png',
    alt: 'EDTECH',
    id: 6,
  },
];

const Honor = () => {
  const { t, i18n } = useTranslation(['home']);

  return (
    <section
      className="container relative mt-24 text-center lg:mt-[280px] xl:mt-[420px] "
      data-expose-event="O_Home_NewExpose">
      <div className="absolute -top-16 left-1/2 w-full translate-x-[-50%]  md:-top-20 lg:-top-52 xl:-top-60">
        <Image
          alt="WuKong"
          className="mx-auto"
          width={1400}
          height={635}
          src="/images/home/honorbg.png"
          quality={100}
          loading="eager"
          priority
        />
      </div>
      <div className="relative z-10 text-center">
        <div className="flex flex-col items-center justify-center space-y-5 lg:flex-row lg:items-stretch lg:space-x-6 lg:space-y-0 xl:space-x-12">
          {honorCards.map(card => (
            <div
              key={card.id}
              className="maxModuleWidth w-full flex-1 rounded-[8px] bg-white px-3 py-6 shadow-wk1 lg:rounded-5xl lg:px-8 lg:py-12 xl:py-15">
              <Image
                className="m-auto w-[239px] lg:w-[416px] xl:w-[580px]"
                alt={t('品牌荣誉-alt')}
                width={580}
                height={136}
                loading="lazy"
                src={card.img}
              />
              <div
                className={cls(
                  i18n.language === 'en' && 'flex flex-col-reverse',
                )}>
                {card.xlTitleKey ? (
                  <>
                    <Title
                      className={cls(
                        'mt-3 lg:mt-6 xl:hidden [&]:leading-normal [&]:lg:leading-normal [&]:xl:leading-normal',
                        i18n.language === 'en' && '[&]:mt-0 [&]:lg:mt-3',
                        i18n.language === 'zh'
                          ? '[&]:text-base [&]:lg:text-[22px] [&]:xl:text-[28px]'
                          : '[&]:text-xl [&]:lg:text-[24px] [&]:xl:text-[34px]',
                      )}
                      innerHTML
                      theme="colorful">
                      {t(card.titleKey)}
                    </Title>
                    <Title
                      className={cls(
                        'mt-3 hidden lg:mt-6 xl:block [&]:leading-normal [&]:lg:leading-normal [&]:xl:leading-normal',
                        i18n.language === 'en' && '[&]:mt-0 [&]:lg:mt-3',
                        i18n.language === 'zh'
                          ? '[&]:text-base [&]:lg:text-[22px] [&]:xl:text-[28px]'
                          : '[&]:text-xl [&]:lg:text-[24px] [&]:xl:text-[34px]',
                      )}
                      innerHTML
                      theme="colorful">
                      {t(card.xlTitleKey)}
                    </Title>
                  </>
                ) : (
                  <Title
                    className={cls(
                      'mt-3 lg:mt-6 [&]:leading-normal [&]:lg:leading-normal [&]:xl:leading-normal',
                      i18n.language === 'en' && '[&]:mt-0 [&]:lg:mt-3',
                      i18n.language === 'zh'
                        ? '[&]:text-base [&]:lg:text-[22px] [&]:xl:text-[28px]'
                        : '[&]:text-xl [&]:lg:text-[24px] [&]:xl:text-[34px]',
                    )}
                    innerHTML
                    theme="colorful">
                    {t(card.titleKey)}
                  </Title>
                )}
                <p
                  className={cls(
                    'mt-5 text-base text-wk-words-5 lg:mt-4 lg:text-xl xl:text-2xl',
                    i18n.language === 'en' && '[&]:mt-3 [&]:lg:mt-6',
                  )}>
                  {t(card.subTitleKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
        <h3
          className="mt-6 text-xs lg:mt-15 lg:text-xl xl:mt-20 xl:text-[28px] [&_strong]:font-black  [&_strong]:text-wk-words-1 "
          dangerouslySetInnerHTML={{ __html: t('品牌荣誉-副标题2') }}
        />
        <div className="mx-auto mt-6  grid grid-cols-3 justify-items-center gap-3 lg:mt-15 lg:max-w-[740px] lg:gap-x-[52px] lg:gap-y-8 xl:mt-20 xl:max-w-full xl:grid-cols-6 xl:gap-6">
          {honorBadges.map(item => (
            <div key={item.id} className="relative">
              <Image
                className=" object-cover"
                src={item.img}
                alt={item.alt}
                width={212}
                height={78}
              />
            </div>
          ))}
        </div>
        <div>
          <LeadButton
            target="_blank"
            theme="colorfulBorder"
            size="xl"
            className="mb-20 mt-6 lg:mb-40 lg:mt-15 xl:mb-50 xl:mt-20"
            traceName="O_Home_MediaModule_CTAClick"
            traceGa4Name="new_entry_HomePage_MediaModuleCTA">
            {t('品牌荣誉-按钮')}
          </LeadButton>
        </div>
      </div>
    </section>
  );
};

export default Honor;
